import { ResponsiveFilters } from 'views/components/ResponsiveFilters/ResponsiveFilters'
import { CropsFilter } from 'views/components/TableFilters'
import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { TableFiltersProps } from 'modules/types'
import { FC } from 'react'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { endpoints } from 'modules/endpoints'
import { useTranslation } from 'react-i18next'
import { ContractTypeFilter } from './ContractTypeFilter'

export const UsContractsFilters: FC<TableFiltersProps> = ({
  setListRequestParams,
  updateFilterState,
  listRequestParams,
}) => {
  const { t } = useTranslation('usContracts')
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
  })

  return (
    <ResponsiveFilters
      listRequestParams={listRequestParams}
      displayClearBtn={displayClearBtn}
      onReset={() =>
        setListRequestParams({
          ...defaultListRequestParams,
        })
      }
      updateFilterState={updateFilterState}
      withSearch={false}
    >
      <CropsFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
      <ABaseTableFilter
        onChange={(sales_person) => updateFilterState({ sales_person })}
        value={listRequestParams.filter.sales_person}
        placeholder={t('responsible')}
        getLabel={(label) => label.full_name}
        endpoint={endpoints.coordinatorsShort()}
        searchField="search"
        id="createdByFilter"
      />
      <ContractTypeFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
    </ResponsiveFilters>
  )
}
